"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACIcon = function (props) {
    return ((props === null || props === void 0 ? void 0 : props.icon) && ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat((props === null || props === void 0 ? void 0 : props.icon) || '', " ").concat((props === null || props === void 0 ? void 0 : props.className) || '') })));
};
exports.ACIcon = ACIcon;
